import React, { useContext, useState } from "react";
import './AbmProducts.css';
import * as XLSX from 'xlsx';
import { createEstructuraABMProducto } from "../../utils/estructuras";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBackspace} from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import productsContext from "../../context/productos/productsContext";
import Swal from 'sweetalert2';

const AbmProducts = ({setShowAbm = () => console.log('Cerrar'), prodToEdit = {}, setProductToEdit = () => console.log('Set product to edit')}) => {
    const [productEditing,setProductEditing] = useState(prodToEdit);
    const [productsData,setProductsData] = useState([createEstructuraABMProducto()]);
    const fileInputRef = useRef(null);

    const pContext = useContext(productsContext);
    const {updateProducto, uploadProducto, actualizarProducts} = pContext;

    const handleChange = (e, i = -1) =>{
        const {name,value,checked} = e.target;
        
        if(Object.keys(productEditing).length > 0){           
            setProductEditing({...productEditing, [name]: name == "enableCons" ? checked : value});
        }else{
            setProductsData((prevData) => {
                let newProds = prevData.slice();
                
                if(value != ''){
                    if(newProds[i].tipPro != '' && newProds[i].artCod != '' && newProds[i].descrp != ''){
                        newProds[i][name] = name == "enableCons" ? checked : value;
                    }else{
                        newProds[i][name] = name == "enableCons" ? checked : value;
                        newProds.length == i+1 && newProds.push(createEstructuraABMProducto());
                    }
                }else{
                    console.log("i");
                    console.log(i);
                    console.log("name");
                    console.log(name);
                    
                    newProds[i][name] = name == "enableCons" ? checked : value;
                    if(newProds[i].tipPro == '' && newProds[i].artCod == '' && newProds[i].descrp == ''){
                        newProds.splice(i,1);
                    }
                }
                return newProds;
            })
        }
    }

    const handleFile = (file) => {
        if(file){
            const reader = new FileReader();
            reader.onload = (evt) => {
                const binaryString = evt.target.result;
                const wb = XLSX.read(binaryString, {type: 'binary'});
                const sheet = wb.Sheets[wb.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet,{header:1});
                
                let dataModelated = jsonData.filter((p,i) => i > 0 && p.length > 0).map((p) => {
                    let objectModelated;
                    p.forEach((value,index) => {
                        switch(index){
                            case 0: 
                                objectModelated = {tipPro: value};
                                break;
                            case 1:
                                objectModelated = {...objectModelated, artCod: value};
                                break;
                            case 2:
                                objectModelated = {...objectModelated, codRed: value};
                                break;
                            case 3: 
                                objectModelated = {...objectModelated, descrp: value};
                                break;
                            case 4: 
                                objectModelated = {...objectModelated, precio: value};
                                break;
                        }
                        objectModelated = {...objectModelated, origen:'M'};
                    })
                    return objectModelated
                });
                
                if(productsData.length > 0){
                    setProductsData([...dataModelated, ...productsData]);
                    setProductsData((prevProducts) => {
                        let newProducts = [...dataModelated];
                        newProducts = [...newProducts, ...productsData.filter((p,i) => !dataModelated.some((pM) => (pM.tipPro == p.tipPro && pM.artCod == p.artCod) || pM.codRed == p.codRed))]
                        return newProducts;
                    });
                }else{
                    setProductsData([...dataModelated]);
                }
            }
            reader.readAsBinaryString(file);
        }
    }

    const handleChangeFile = (e) => {
        const file = e.target.files[0];
        handleFile(file);
    }

    const handleDelete = (prod,i) => {
        if(prod.tipPro != ''){
            setProductsData((prevData) => {
                let newData = prevData.filter((p,index) => index != i);
                return newData;
            })
        }
    }

    const handleSave = async() => {
        if(Object.keys(productEditing).length > 0){
            let res = await updateProducto(productEditing);
            if(res.data?.data?.tipPro){
                Swal.fire({
                    title:'Éxito!',
                    text:'Producto actualizado correctamente',
                    icon:'success'
                })
            }
        }else{
            if(productsData.some((p,i) => i < productsData.length - 1 && (p.tipPro == '' || p.artCod == '' || p.descrp == ''))){
                let result = await Swal.fire({
                    title: `Ops!`,
                    icon: 'warning',
                    text: 'Ciertos productos estan sin completar, desea omitirlos y guardar igual?',
                    showConfirmButton: true,
                    showCancelButton: true, // Habilita el botón de cancelar
                    confirmButtonColor: '#ff0000',
                    denyButtonColor: '#3d4d87',
                    confirmButtonText: 'Sí, estoy seguro',
                    cancelButtonText:'No',
                    allowEnterKey: true
                })
                if (result.isConfirmed ) {
                }else{
                    return false;
                }
            }
            let productsCompleted = productsData.filter((p) => p.tipPro != '' && p.artCod != '' && p.descrp != '');
            let counterSaved = 0;
            let counterFail = 0;
            for(const p of productsCompleted){
                try {
                    let res = await uploadProducto(p);
                    if(res == false) throw new Error("Clave Duplicada para el Producto " + p.artCod);
                    counterSaved++;
                } catch (error) {
                    console.log("error intentando guardar el nuevo producto " + p.tipPro + ' ' +p.artCod);
                    console.log(error);
                    counterFail++;
                }
            }
            actualizarProducts();
            Swal.fire({
                title:'Contador',
                icon: counterFail == 0 && counterSaved > 0 ? 'success' : counterFail > 0 && counterSaved == 0 ? 'error' : 'warning',
                html: `Productos guardados con Éxito: ${counterSaved}. <br>
                Productos imposibles de guardarlos: ${counterFail}`,
            })
        }
        handleClose();
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFile(droppedFile);
    }

    const handleClose = () => {
        if(Object.keys(prodToEdit).length > 0){
            setProductEditing({});
            setProductToEdit({});
        }else{
            setShowAbm(false)
        }
    }

    return <div className="abmProductsModal">
        <div className="abmProductsDiv">
            <button className="minimizarBtn" onClick={handleClose}>X</button>
            <h2>{Object.keys(productEditing).length == 0 ? 'Alta de Producto' : 'Edición de Producto'}</h2>

            <div className="productosLeidosSubtabla">
                <div className={`${Object.keys(productEditing).length == 0 ? '' : 'fiveColumns'} labelsSubtablas`}>
                    {Object.keys(productEditing).length == 0 && <label></label>}
                    <label>Tipo Producto</label>
                    <label>Codigo Producto</label>
                    <label>Cod. Reducido</label>
                    <label>Descripción</label>
                    <label>Precio</label>
                    <label>Visible para Consumos</label>
                </div>
                {Object.keys(productEditing).length > 0 
                ? 
                <div className={`${Object.keys(productEditing).length == 0 ? '' : 'fiveColumns'} productLoaded`}>
                    <input name="tipPro" onChange={(e)=>handleChange(e)} value={productEditing.tipPro}></input>
                    <input name="artCod" onChange={(e)=>handleChange(e)} value={productEditing.artCod}></input>
                    <input name="codRed" onChange={(e)=>handleChange(e)} value={productEditing.codRed}></input>
                    <input name="descrp" onChange={(e)=>handleChange(e)} value={productEditing.descrp}></input>
                    <input name="precio" type="number" onChange={(e)=>handleChange(e)} value={productEditing.precio}></input>
                    <input type="checkbox" name="enableCons" checked={productEditing.enableCons} value={productEditing.enableCons} onChange={(e)=>handleChange(e)}/>
                </div> 
                : 
                productsData.map((p,i) => <div className="productLoaded" key={i}>
                    <FontAwesomeIcon className="iconDelete" icon={faBackspace} color="red" onClick={(e)=>handleDelete(p,i)}/>
                    <input name="tipPro" onChange={(e)=>handleChange(e,i)} value={p.tipPro}></input>
                    <input name="artCod" onChange={(e)=>handleChange(e,i)} value={p.artCod}></input>
                    <input name="codRed" onChange={(e)=>handleChange(e,i)} value={p.codRed}></input>
                    <input name="descrp" onChange={(e)=>handleChange(e,i)} value={p.descrp}></input>
                    <input name="precio" type="number" onChange={(e)=>handleChange(e,i)} value={p.precio}></input>
                    <input type="checkbox" name="enableCons" checked={p.enableCons} value={p.enableCons} onChange={(e)=>handleChange(e,i)}/>
                </div>)}
            </div>
            {Object.keys(productEditing).length == 0 && <a href="/templateProducto.xlsx" download>Descargar template.xlsx</a>}
            {Object.keys(productEditing).length == 0 && <div className="inputFileXlsx dropNivel1" 
                onClick={() => fileInputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
            >
                <span accept=".xlsx,.xls" htmlFor='excelFile'>O cargue los productos arrastrando un archivo .xlsx a esta sección</span>
                <input ref={fileInputRef} type="file" id="excelFile" style={{display:'none'}} onChange={(e)=>handleChangeFile(e)} />
            </div>}
            <button className="saveBtn" onClick={handleSave}>Guardar</button>
        </div>
    </div>
}

export default AbmProducts;